import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IContentProps } from '../models/content-props'
import { ISearchAppState } from '../index';
import { Pagination } from './pagination/pagination';
import * as _ from 'lodash';
import { ISort, searchSortModel, GetSorts, IGlobalSort } from '../models/sorts';
import { ISearchResultDTO, ISearchRequestDTO, ITrackClick, ITermDTO, IAutocompleteResults, DefaultAutoCompleteResults, FILE_EXTENSION_TERM } from '../DTO/search';
import { FetchPendingAction } from '../middleware/fetch-middleware';
import { SearchError } from './error/error';
import { DropdownSelect, IDropdownOption, IDropdownSelectProps } from './inputs/dropdown';
import { SearchBar } from './searching/search-bar';
import { Facets } from './filters/facets';
import { SortGroup } from './filters/sort';
import { ResultList } from './results/result-list';
import { fetchAutoCompleteResults, getSearchResults, trackClick } from '../ducks/search-api';
import { getContentProps } from '../ducks/content-api';
import { ResultCount } from './results/result-count';
import { SearchSuggestion } from './searching/search-suggestion';

interface IStateProps {
    contentProps: IContentProps,
    searchResults: ISearchResultDTO,
}

interface IDispatchProps {
    getContentProps: () => FetchPendingAction;
    getSearchResults: (criteria: ISearchRequestDTO) => FetchPendingAction;
    trackClick: (criteria: ITrackClick) => FetchPendingAction;
}

interface IOwnProps {
    contentId: string;
    dateSortRelevanceFilter: number;
    setQueryParams: (params: { [key: string]: string[] }) => void
    initialParams: { [key: string]: string[] }
}

type IProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    searchText: string;
    pageSize: number;
    pageNumber: number;
    isLoading: boolean;
    hasSearched: boolean;
    selectedTerms: ITermDTO[];
    context: string;
    autoCompleteResults: IAutocompleteResults;
    sortsModel: ISort[];
    fetchError: boolean;
}

export class Search extends React.Component<IProps, IState> {
    static defaultProps = {
        contentProps: {},
        searchResults: DefaultAutoCompleteResults,
    }
    constructor(props) {
        super(props);

        const searchText = props.initialParams.q && decodeURIComponent(props.initialParams.q[0]).split('+').join(' ') || '';
        delete props.initialParams.q;

        const pageSize = props.initialParams.pageSize && +props.initialParams.pageSize[0] || this.getDefaultPageSize();
        delete props.initialParams.pageSize;

        const pageNumber = props.initialParams.pageNumber && +props.initialParams.pageNumber[0] || 1;
        delete props.initialParams.pageNumber;

        const selectedTerms = props.initialParams.selectedTerms ? props.initialParams.selectedTerms.map(t => JSON.parse(decodeURIComponent(t))) : [];
        delete props.initialParams.selectedTerms;

        const context = props.initialParams.context && decodeURIComponent(props.initialParams.context[0]) || '';
        delete props.initialParams.context;

        const selectedSortId = props.initialParams.sortId && props.initialParams.sortId[0] || '';
        const sortsModel = this.getUpdatedSorts(selectedSortId, true);

        this.state = {
            searchText,
            pageSize,
            pageNumber,
            isLoading: false,
            hasSearched: false,
            context,
            selectedTerms,
            autoCompleteResults: {
                hits: [],
                isActive: false,
                activeHit: null,
            },
            sortsModel,
            fetchError: false,
        };
    }

    componentDidMount() {
        this.props.getContentProps();
        this.getSearchResults();
    }

    render() {
        const { contentProps, searchResults } = this.props;

        return (
            <div className="adage-search-container">

                {this.state.fetchError &&
                    <SearchError
                        errorText={contentProps.generalErrorText}
                        onDismiss={() => this.setErrorState(false)}
                    />
                }



                <div className="adage-search-container-inner">
                    {!searchResults.hideFiltersAndCategories &&
                        <div className="adage-search-filters">
                            <Facets
                                facets={searchResults.facets}
                                selectedTermIds={this.state.selectedTerms ? this.state.selectedTerms.map(term => term.id) : []}
                                onTermClick={this.setFacetTerm}
                                onResetClick={this.resetFacets}
                                contentProps={contentProps} />
                        </div>
                    }

                    <div className="adage-search-content">
                        <div className='adage-search-app-form'>

                            <SortGroup
                                sortGroupName='sorts'
                                sorts={GetSorts(this.state.sortsModel, contentProps)}
                                onSort={(sort: IGlobalSort<ISearchResultDTO>) => this.onSortSelect(sort.sortId)}
                                sortLabel={contentProps.sortsLabel}
                            />

                            <SearchBar
                                id='site-search-form'
                                searchText={this.state.searchText}
                                onSearch={this.onSearch}
                                onChange={this.onInputChange}
                                searchButtonText={contentProps.searchButtonText}
                                autoCompleteResults={this.state.autoCompleteResults}
                                setActiveHit={this.setAutoCompleteActiveHit}
                                setAutoCompleteActive={this.setAutoCompleteActive}
                                searchSuggestionText={contentProps.searchSuggestionText}
                                searchSuggestion={searchResults.suggestion}
                                loading={this.state.isLoading}
                                placeHolder={contentProps.searchPlaceholderText}
                                contextComponent={<DropdownSelect
                                    onDropdownSelect={this.setContext}
                                    placeHolder={contentProps.contextPlaceholderText}
                                    selectedId={this.state.context}
                                    values={contentProps.contextItems ? contentProps.contextItems.map(x => {
                                        return Object.freeze({
                                            id: x,
                                            display: x
                                        }) as IDropdownOption
                                    }) : []}
                                />}
                            />
                        </div>
                        <div className="adage-search-results-info">
                            <ResultCount
                                content={contentProps}
                                currentPage={this.state.pageNumber}
                                totalResults={searchResults.totalResults}
                                pageSize={contentProps.pageSize}
                                currentPageResults={searchResults.results ? searchResults.results.length : 0}
                                isLoading={this.state.isLoading}
                            />

                            <SearchSuggestion
                                searchSuggestionText={contentProps.searchSuggestionText}
                                suggestion={searchResults.suggestion}
                                loading={this.state.isLoading}
                                onSuggestionClick={() => this.onSuggestionClick(searchResults.suggestion)}
                            />
                        </div>

                        <ResultList
                            results={searchResults.results}
                            onResultClick={this.onResultCLick}
                            hideCategories={searchResults.hideFiltersAndCategories}
                        />
                        <div className="adage-search-footer">
                            <Pagination
                                totalItems={searchResults.totalResults}
                                pageSize={this.state.pageSize}
                                pageNumber={this.state.pageNumber}
                                onPageSelect={(pageNumber) => this.setPageNumber(pageNumber)} />
                            <ResultCount
                                content={contentProps}
                                currentPage={this.state.pageNumber}
                                totalResults={searchResults.totalResults}
                                pageSize={contentProps.pageSize}
                                currentPageResults={searchResults.results ? searchResults.results.length : 0}
                                isLoading={this.state.isLoading}
                            />
                        </div>
                    </div>
                </div>

            </div>

        )
    }

    onResultCLick = (hitId) => {
        this.props.trackClick({
            hitId: hitId,
            searchTerm: this.state.searchText,
            trackingId: this.props.searchResults.trackingId
        }).fetch;
    }

    onSuggestionClick = (suggestion: string) => {
        this.setState({ searchText: suggestion });
        this.onSearch(suggestion);
    }

    getSearchResults = () => {
        // Get just the selected facets and selected terms
        let selectedFacets = this.selectedFacets;
        let selectedSort = this.state.sortsModel.filter(x => x.selected)[0];

        this.setState({ isLoading: true, hasSearched: true },
            () => {
                this.props.getSearchResults({
                    searchTerm: this.state.searchText,
                    pageSize: this.state.pageSize,
                    pageNumber: this.state.pageNumber,
                    facets: selectedFacets,
                    context: this.state.context,
                    sortField: selectedSort.sortField,
                    sortDirection: selectedSort.direction,
                    dateSortRelevanceFilter: this.props.dateSortRelevanceFilter,
                    includeSuggestion: true,
                } as ISearchRequestDTO)
                    .fetch
                    .then(() => {
                        this.setState({
                            isLoading: false,
                            fetchError: false,
                        });
                    })
                    .catch(() => {
                        this.setState({ fetchError: true });
                    });
            });
    }

    get selectedFacets() {
        let facetMap = new Map<string, ITermDTO[]>();
        [].forEach.call(this.state.selectedTerms, (term: ITermDTO) => {
            term.selected = true;
            if (facetMap.has(term.fieldName)) {
                facetMap.get(term.fieldName).push(term);
            }
            else {
                facetMap.set(term.fieldName, [term]);
            }
        });

        return Array.from(facetMap.keys()).map(key => Object.freeze({ fieldName: key, terms: facetMap.get(key) }));;
    }

    onSearch = (searchText: string) => {
        this.setState({ pageNumber: 1, selectedTerms: [], searchText: searchText }, () => {
            this.setAutoCompleteActive(false);
            this.getSearchResults();
            this.onUpdateQuery();
        });
    }

    setContext = (context: string) => {
        this.setState({ context: context, pageNumber: 1, selectedTerms: [] },
            () => {
                this.onUpdateQuery();
                this.getSearchResults();
            });
    }

    onInputChange = (searchText: string) => {
        this.getAutoCompleteResults(searchText);
    }

    onSortSelect = (sortId: string) => {
        let updatedSorts = this.getUpdatedSorts(sortId);

        this.setState({
            sortsModel: updatedSorts,
            pageNumber: 1
        }, () => {
            this.onUpdateQuery();
            this.getSearchResults();
        });
    }

    getUpdatedSorts = (sortId: string, onPageLoad = false) => {
        let sortsModel = onPageLoad ? searchSortModel : this.state.sortsModel
        return sortsModel.map(this.updateSort(sortId));
    }

    get selectedSortId() {
        return this.state.sortsModel.filter(x => x.selected)[0].id;
    }

    updateSort(sortId: string): (sort: ISort) => ISort {
        if (!sortId) {
            sortId = 'relevance';
        }

        return function (sort: ISort) {
            sort.selected = sort.id === sortId;
            return sort;
        }
    }

    getAutoCompleteResults = (searchText: string) => {
        if (searchText.length > 2) {
            fetchAutoCompleteResults(searchText)
                .then((data) => {
                    let results = { ...DefaultAutoCompleteResults }

                    if (data) {
                        results.activeHit = -1;
                        results.hits = data.hits;
                        results.isActive = true;
                    }
                    this.setState({
                        autoCompleteResults: results
                    });
                })

            this.setAutoCompleteActive(true);
        }
    }

    setAutoCompleteActive = (value: boolean) => {
        let results = { ...this.state.autoCompleteResults }
        results.isActive = value;
        results.activeHit = -1;

        this.setState({
            autoCompleteResults: results
        });
    }

    setAutoCompleteActiveHit = (index: number) => {
        let results = { ...this.state.autoCompleteResults }
        results.activeHit = index;

        this.setState({
            autoCompleteResults: results
        });
    }

    setFacetTerm = (id: number) => {
        this.setState(prevState => {
            let selectedTermIds = prevState.selectedTerms.map(term => term.id);
            let selectedTerms = prevState.selectedTerms;
            let index = selectedTermIds.indexOf(id);
            if (index >= 0) {
                selectedTerms.splice(index, 1);
            }
            else {
                selectedTerms.push(this.props.searchResults.facets
                    .reduce((terms, facet) => [...terms, ...facet.terms], [])
                    .filter(t => t.id == id)[0]);
            }

            return {
                selectedTerms: selectedTerms,
                pageNumber: 1
            };

        }, () => {
            this.onUpdateQuery();
            this.getSearchResults();
        });
    }

    resetFacets = () => {
        // Clear all doesn't effect things that are in the file extension group
        this.setState(prevState => {
            let selectedTerms = prevState.selectedTerms
                .filter(term => term.fieldName === FILE_EXTENSION_TERM);

            return { selectedTerms, pageNumber: 1 };
        }, () => {
            this.onUpdateQuery();
            this.getSearchResults();
        });
    }

    setSearchText = (searchText: string) => {
        this.setState({ searchText: searchText }, this.onUpdateQuery);
    }

    setPageNumber = (pageNumber: number) => {
        this.setState({ pageNumber: pageNumber }, () => { this.onUpdateQuery(); this.getSearchResults(); });
    }

    onUpdateQuery = () => {
        const query: { [key: string]: string[] } = {};

        if (this.state.searchText.length > 0) {
            query.q = [this.state.searchText];
        }
        if (this.state.pageNumber) {
            query.pageNumber = [this.state.pageNumber.toString()];
        }
        if (this.state.context) {
            query.context = [this.state.context];
        }
        if (this.state.selectedTerms) {
            query.selectedTerms = this.state.selectedTerms.map(term => encodeURIComponent(JSON.stringify(Object.freeze({
                id: term.id,
                fieldName: term.fieldName,
                term: term.term
            }))));
        }

        if (this.state.sortsModel) {
            query.sortId = [this.selectedSortId];
        }

        // Update the url
        this.props.setQueryParams(query);
    }

    setErrorState = (value: boolean) => {
        this.setState({ fetchError: value });
    }

    getDefaultPageSize = () => {
        if ((window as any).bootstrap.pageSize) {
            return (window as any).bootstrap.pageSize;
        }
        return 10;
    }
}

const mapStateToProps = (state: ISearchAppState): IStateProps => ({
    contentProps: state.contentState.props,
    searchResults: state.searchResults.results,
})

const mapDispatchToProps = (dispatch, ownProps: IOwnProps): IDispatchProps => bindActionCreators({
    getContentProps: () => getContentProps(ownProps.contentId) as any,
    getSearchResults: getSearchResults as any,
    trackClick: trackClick as any
}, dispatch)


export const SearchApp = connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(Search);